import React from 'react';
import { connect } from 'react-redux';
import ReactTooltip from "react-tooltip";
import NavbarHeader from '../components/NavbarHeader';
import NavSidebar from '../components/nav-sidebar/NavSidebar';
import ReduxModal from '../components/ReduxModal';
import MobileNavDropdown from '../components/MobileNavDropdown';
import { pageMounted, pageResized } from '../reducers/documentProps';

var getMainStyle = (isWizardOpen, wizardWidth, wizardPosition, isSidebarOpen, colour) => {
    var defaultStyle = {
        background: colour,
        paddingRight: 30,
        paddingLeft: 30,
    };

    if(! isWizardOpen) {
        if(isSidebarOpen) {
            return {
                ...defaultStyle,
                paddingRight: 30,
                paddingLeft: 280,
            };
        }

        return defaultStyle;
    }

    return wizardPosition == 'right'
        ? {...defaultStyle, paddingRight: wizardWidth + 20, paddingLeft: 20}
        : {...defaultStyle, paddingLeft: wizardWidth + 20, paddingRight: 20};
};

@connect(
    state => ({
        isWizardOpen: state.logActivityWizard.isOpen,
        wizardPosition: state.logActivityWizard.wizardPosition,
        wizardWidth: state.logActivityWizard.wizardWidth,
        isSidebarOpen: state.sidebar.isOpen,
        windowInnerHeight: state.documentProps.windowInnerHeight,
        mainBackground: state.theme.selected.mainBackground.value
    }),
    { pageMounted, pageResized }
)
export default class AuthenticatedLayout extends React.Component {

    componentDidMount() {
        this.props.pageMounted();
        window.onresize = () => {
            this.props.pageResized();
        };
    }

    onBodyClick(e) {
        var bodyClick = new CustomEvent("bodyClick", {
            detail: {
                classList: e.target.classList
            }
        });
        window.dispatchEvent(bodyClick);
    }

    render() {
        var { isWizardOpen, wizardPosition, wizardWidth, isSidebarOpen, mainBackground } = this.props;
        var sidebarWidth = isSidebarOpen ? 250 : 0;

        var mainStyle = getMainStyle(isWizardOpen, wizardWidth, wizardPosition, isSidebarOpen, mainBackground);

        var sidebarUl = document.querySelector('.nav-sidebar');
        var sidebarUlHeight = null;
        if(sidebarUl) {
            sidebarUlHeight = window.innerHeight - sidebarUl.getBoundingClientRect().top;
        }
        
        return (
            <div onClick={this.onBodyClick.bind(this)}>
                <ReactTooltip  place='top' type='dark' effect='solid'/>

                <NavSidebar width={sidebarWidth} sidebarUlHeight={sidebarUlHeight} />
              
                <NavbarHeader />

                <div className="mm-page">
                    <div id="main" className="main" style={mainStyle}>
                        {this.props.children}
                    </div>
                </div>
                <ReduxModal />
                <MobileNavDropdown />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/layout/AuthenticatedLayout.js